<script lang="ts">
	import Header from '$lib/components/sections/Header.svelte';
	import Footer from '$lib/components/sections/Footer.svelte';
	import DocsLayout from '$lib/components/docs/DocsLayout.svelte';

	let { children } = $props();
</script>

<svelte:head>
	<!--
		Note: title + meta description are intentionally NOT set here.
		Every child route (guides/+page.svelte and guides/[slug]/+page.svelte)
		sets its own <title> and <meta name="description">. Defining them in the
		layout too caused duplicate tags on every guides page (Ahrefs Site Audit:
		"Multiple meta description tags", Critical).
	-->
</svelte:head>

<!-- Header spans full width -->
<Header />

<!-- Use shared DocsLayout component -->
<DocsLayout mode="guides">
	{@render children?.()}
</DocsLayout>

<!-- Footer spans full width -->
<Footer />